/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for SchoolSubscriptionPaymentCtl controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_VERSUSCLIENT, CLIENT_CONTEXT_TOKEN_VERSUSCLIENT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, SchoolSubscriptionInfo, SchoolSubPayDto, PaymentResponseDto } from "../models";

@Injectable({ providedIn: "root" })
export class SchoolSubscriptionPaymentCtlService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_VERSUSCLIENT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_VERSUSCLIENT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'VersusClient');
    }

    subscriptionInfo(idSchool: number, idStudent: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<SchoolSubscriptionInfo>;
    subscriptionInfo(idSchool: number, idStudent: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<SchoolSubscriptionInfo>>;
    subscriptionInfo(idSchool: number, idStudent: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<SchoolSubscriptionInfo>>;
    subscriptionInfo(idSchool: number, idStudent: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/public/schools/payment/subscriptions`;

        let params = new HttpParams();
        if (idSchool != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idSchool, 'idSchool');
        }
        if (idStudent != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idStudent, 'idStudent');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    subscriptionPayment(schoolSubPayDto: SchoolSubPayDto, observe?: 'body', options?: RequestOptions<'json'>): Observable<PaymentResponseDto>;
    subscriptionPayment(schoolSubPayDto: SchoolSubPayDto, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<PaymentResponseDto>>;
    subscriptionPayment(schoolSubPayDto: SchoolSubPayDto, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<PaymentResponseDto>>;
    subscriptionPayment(schoolSubPayDto: SchoolSubPayDto, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/public/schools/payment/subscriptions`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: schoolSubPayDto,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    subscriptionInfo1(idSchool: number, idStudent: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<SchoolSubscriptionInfo>;
    subscriptionInfo1(idSchool: number, idStudent: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<SchoolSubscriptionInfo>>;
    subscriptionInfo1(idSchool: number, idStudent: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<SchoolSubscriptionInfo>>;
    subscriptionInfo1(idSchool: number, idStudent: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/schools/payment/subscriptions`;

        let params = new HttpParams();
        if (idSchool != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idSchool, 'idSchool');
        }
        if (idStudent != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idStudent, 'idStudent');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    subscriptionPayment1(schoolSubPayDto: SchoolSubPayDto, observe?: 'body', options?: RequestOptions<'json'>): Observable<PaymentResponseDto>;
    subscriptionPayment1(schoolSubPayDto: SchoolSubPayDto, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<PaymentResponseDto>>;
    subscriptionPayment1(schoolSubPayDto: SchoolSubPayDto, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<PaymentResponseDto>>;
    subscriptionPayment1(schoolSubPayDto: SchoolSubPayDto, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/schools/payment/subscriptions`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: schoolSubPayDto,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getPaymentFees(idSchool: number, amount: number, network: string, observe?: 'body', options?: RequestOptions<'text'>): Observable<number>;
    getPaymentFees(idSchool: number, amount: number, network: string, observe?: 'response', options?: RequestOptions<'text'>): Observable<HttpResponse<number>>;
    getPaymentFees(idSchool: number, amount: number, network: string, observe?: 'events', options?: RequestOptions<'text'>): Observable<HttpEvent<number>>;
    getPaymentFees(idSchool: number, amount: number, network: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/public/schools/payment/fees`;

        let params = new HttpParams();
        if (idSchool != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idSchool, 'idSchool');
        }
        if (amount != null) {
            params = HttpParamsBuilder.addToHttpParams(params, amount, 'amount');
        }
        if (network != null) {
            params = HttpParamsBuilder.addToHttpParams(params, network, 'network');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            responseType: 'text',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getPaymentFees1(idSchool: number, amount: number, network: string, observe?: 'body', options?: RequestOptions<'text'>): Observable<number>;
    getPaymentFees1(idSchool: number, amount: number, network: string, observe?: 'response', options?: RequestOptions<'text'>): Observable<HttpResponse<number>>;
    getPaymentFees1(idSchool: number, amount: number, network: string, observe?: 'events', options?: RequestOptions<'text'>): Observable<HttpEvent<number>>;
    getPaymentFees1(idSchool: number, amount: number, network: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/schools/payment/fees`;

        let params = new HttpParams();
        if (idSchool != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idSchool, 'idSchool');
        }
        if (amount != null) {
            params = HttpParamsBuilder.addToHttpParams(params, amount, 'amount');
        }
        if (network != null) {
            params = HttpParamsBuilder.addToHttpParams(params, network, 'network');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            responseType: 'text',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
